import { Type } from '@sinclair/typebox';
function createFromChangelogAction(action, changes) {
    return Type.Object({
        action: Type.Literal(action),
        changes: Type.Object(changes),
    });
}
function createToChangelogAction(action, changes) {
    return Type.Object({
        action: Type.Literal(action),
        changes: Type.Object(changes),
        valid: Type.Literal(true),
    });
}
export function createChangelogActions(action, changes) {
    return {
        To: createToChangelogAction(action, changes),
        From: createFromChangelogAction(action, changes),
    };
}
export function createChangelogOptions(type, actions) {
    return {
        type,
        actions,
    };
}
